import { Heading } from '@digitools/honest-react';
import React, { useEffect } from 'react';
import { TEALIUM_PAGE_VIEW } from '../../../constants/tealiumConstants';
import useTealium from '../../../hooks/useTealium';
import ContactInfoBox from '../shared/ContactInfoBox';
const DeactivatedPage = () => {
    const { trackView } = useTealium();
    useEffect(() => {
        trackView({
            page_l3: TEALIUM_PAGE_VIEW.PAGE_L3.DEACTIVATED,
            page_l4: TEALIUM_PAGE_VIEW.PAGE_L4.DEACTIVATED.VIEW,
        });
    }, []);
    return (<div className={'mb-5'} data-testid='deactivated-page'>
      <Heading elemType={'h1'} elemStyle={'h1'} className={'mt-5'}>
        You do not have access
      </Heading>
      <p>
        If you believe that you have received this message in error please contact us.
      </p>
      <ContactInfoBox />
    </div>);
};
export default DeactivatedPage;
